<template>
  <div>
    <LDBsTable
      url="os"
      defaultSort="status"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
    >
      <div class="form-group col-lg-4">
        <label for="status">{{ $t("status") }}</label>
        <Combobox
          class="bg-white"
          name="status"
          :placeholder="$t('select_a_item')"
          :options="os.statusOsTests"
          :initial-value="query.status"
          label="name"
          v-model="query.status"
          :reduce="(status) => status.id"
          disabled
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="services">{{ $t("services") }}</label>
        <Combobox
          class="bg-white"
          name="services"
          :placeholder="$t('select_a_item')"
          :options="os.serviceTypes"
          :initial-value="query.services"
          label="name"
          v-model="query.services"
          :reduce="(serviceType) => serviceType.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="cause_of_maintance">{{ $t("cause_of_maintance") }}</label>
        <Combobox
          class="bg-white"
          name="cause_of_maintance"
          :placeholder="$t('select_a_item')"
          :options="[
            { label: 'SIM', value: true },
            { label: 'NÃO', value: false },
          ]"
          :initial-value="query.causeOfMaintance"
          v-model="query.causeOfMaintance"
          :reduce="(causeOfMaintance) => causeOfMaintance.value"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="reason">{{ $t("reason") }}</label>
        <Combobox
          class="bg-white"
          name="reason"
          :placeholder="$t('select_a_item')"
          :options="os.maintanceReasons"
          :initial-value="query.maintanceReason"
          label="name"
          v-model="query.maintanceReason"
          :reduce="(maintanceReason) => maintanceReason.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="os_number">{{ $t("os_number") }}</label>
        <input
          type="text"
          id="os_number"
          name="os_number"
          class="form-control"
          :placeholder="$t('ph_os_number')"
          v-model="query.number"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t("garage_accredited") }}</label>
        <Combobox
          class="bg-white"
          name="garage_accredited"
          :placeholder="$t('select_a_item')"
          :options="os.garages"
          :initial-value="query.garageAccredited"
          label="fantasyName"
          v-model="query.garageAccredited"
          :reduce="(garage) => garage.id"
        />
      </div>

      <div class="form-group col-lg-8">
        <label for="contract">{{ $t("contract") }}</label>
        <Combobox
          class="bg-white"
          name="contract"
          :placeholder="$t('select_a_item')"
          :options="os.contracts"
          :initial-value="query.contract"
          label="contracts"
          v-model="query.contract"
          :reduce="(contract) => contract.id_contrato"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="serial">{{ $t("new_equipment") }}</label>
        <input
          type="text"
          id="serial"
          name="serial"
          class="form-control"
          :placeholder="$t('ph_new_equipment')"
          v-model="query.serial"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="serial">{{ $t("old_equipment") }}</label>
        <input
          type="text"
          id="withdrawnSerial"
          name="withdrawnSerial"
          class="form-control"
          :placeholder="$t('ph_old_equipment')"
          v-model="query.withdrawnSerial"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="board">{{ $t("board") }}</label>
        <input
          type="text"
          id="board"
          name="board"
          class="form-control"
          :placeholder="$t('ph_board')"
          v-model="query.board"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="vehicleType">{{ $t("vehicle_type") }}</label>
        <Combobox
          class="bg-white"
          name="vehicle_type"
          :placeholder="$t('select_a_item')"
          :options="os.vehicleTypes"
          :initial-value="query.vehicleType"
          label="TPV_DSC"
          v-model="query.vehicleType"
          :reduce="(vehicleType) => vehicleType.TPV_COD"
        />
      </div>

      <div class="form-group col-lg-2">
        <label for="period_start">{{ $t("period_start") }} (Teste)</label>
        <input
          type="date"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="query.testDateStart"
        />
      </div>

      <div class="form-group col-lg-2">
        <label for="period_end">{{ $t("period_end") }} (Teste)</label>
        <input
          type="date"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="query.testDateEnd"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="problems_found">{{ $t("problems_found") }}</label>
        <input
          type="text"
          id="problems_found"
          name="problems_found"
          class="form-control"
          :placeholder="$t('ph_problems_found')"
          v-model="query.msgFinish"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="finishedBy">{{ $t("finished_by") }}</label>
        <Combobox
          class="bg-white"
          name="finishedBy"
          :placeholder="$t('select_a_item')"
          :options="os.users"
          :initial-value="query.finishedBy"
          label="name"
          v-model="query.finishedBy"
          :reduce="(finishedBy) => finishedBy.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="os_resolved">{{ $t("os_resolved") }}</label>
        <Combobox
          class="bg-white"
          name="os_resolved"
          :placeholder="$t('select_a_item')"
          :options="[
            { label: 'SIM', value: true },
            { label: 'NÃO', value: false },
          ]"
          :initial-value="query.osResolved"
          v-model="query.osResolved"
          :reduce="(osResolved) => osResolved.value"
        />
      </div>
    </LDBsTable>

    <!-- MODAL CHANGE CAUSE OR REASON -->
    <div
      class="modal fade"
      id="modalEditOS"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalEditOSLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalEditOSLabel">
              Editar OS
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group" v-if="!loading && serviceTypeOSToEdit == 2">
              <label for="causeOfMaintance">{{ $t("cause_of_maintance") }}</label>
              <Combobox
                class="bg-white"
                name="causeOfMaintance"
                :placeholder="$t('select_a_item')"
                :options="os.causesOfMaintance"
                :initial-value="dataToUpdate.causeOfMaintance"
                label="name"
                v-model="dataToUpdate.causeOfMaintance"
                :reduce="(causeOfMaintance) => causeOfMaintance.id"
                v-validate="'required'"
                :hasErrors="errors.has('cause_of_maintance')"
              />

              <small v-show="errors.has('causeOfMaintance')" class="form-text text-muted">
                {{ errors.first('cause_of_maintance') }}
              </small>
            </div>

            <div
              class="form-group"
              v-if="!loading && serviceTypeOSToEdit == 2"
            >
              <label for="reasonToUpdate">{{ $t("reason") }}</label>
              <Combobox
                class="bg-white"
                name="reasonToUpdate"
                :placeholder="$t('select_a_item')"
                :options="onlyMaintanceReasonsActive"
                :initial-value="dataToUpdate.reason"
                label="name"
                v-model="dataToUpdate.reason"
                :reduce="(maintanceReason) => maintanceReason.id"
              />
            </div>

            <div class="form-group" v-if="!loading">
              <label for="obs">{{ $t('obs') }}</label>
              <textarea
                name="obs"
                id="obs"
                rows="3"
                class="form-control"
                :placeholder="$t('ph_obs')"
                v-model="dataToUpdate.obs"
              />
            </div>

            <div class="switch form-group" v-if="!loading">
              <label for="generateBilling">{{ $t('generate_billing') }}</label>
              <div class="onoffswitch2">
                <input
                  type="checkbox"
                  class="onoffswitch2-checkbox"
                  id="generateBilling"
                  v-model="dataToUpdate.generateBilling"
                >

                <label class="onoffswitch2-label" for="generateBilling">
                  <span class="onoffswitch2-inner"></span>
                  <span class="onoffswitch2-switch"></span>
                </label>
              </div>
            </div>

            <div class="d-flex justify-content-center mb-3" v-if="loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              type="button"
              class="btn btn-primary mr-3 mt-3"
              @click="updateOs"
              :loading="isLoading"
            >
              {{ $t("save") }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CONFIRM RESOLVE OS -->
    <div class="modal fade" id="modalConfirmResolveOS" tabindex="-1" role="dialog" aria-labelledby="modalConfirmResolveOSLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmResolveOSLabel">Marcar como resolvida</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                OS: <strong>{{ osDataToMarkResolved.id }}</strong>
              </li>
              <li>
                PLACA: <strong>{{ osDataToMarkResolved.board }}</strong>
              </li>
              <li>
                CONTRATO: <strong>{{ osDataToMarkResolved.contract }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer d-flex justify-content-between align-items-center py-0">
            <p class="mb-0">
              <span class="label label-danger" v-show="!canResolve">Causa de manutenção não informada</span>
            </p>

            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-secondary block m-b mt-3 mr-2"
                data-dismiss="modal"
                :disabled="isLoading"
              >
                {{ $t('close') }}
              </button>

              <LoaderButton
                class="mt-3"
                @click="confirmOSResolved"
                :loading="isLoading"
                :disabled="!canResolve"
              >
                {{ $t('confirm') }}
              </LoaderButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL UPLOAD -->
    <div
      ref='modalUpload'
      id="modalUpload"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalUpload"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalUploadLabel">OS {{ osToUpload }}</h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed="alert.show = false"
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <!-- Input único para múltiplos arquivos -->
            <b-form-file
              multiple
              v-model="inputFiles"
              @change="handleFiles"
              placeholder="Selecione os arquivos..."
              drop-placeholder="Arraste aqui..."
              accept="image/*,video/*"
              browse-text="Buscar"
            />

            <b-table
              striped
              hover
              small
              :items="files"
              :fields="[
                { key: 'name', label: 'Arquivo' },
                { key: 'status', label: 'Status', class: 'text-center' },
                { key: 'actions', label: '', class: 'text-right' }
              ]"
              class="mt-3"
              empty-text="Nenhum arquivo selecionado"
            >
              <template #cell(actions)="row">
                <b-button
                  size="sm"
                  variant="danger"
                  @click="removeFile(row.index)"
                >
                  <i class="fas fa-times"></i>
                </b-button>
              </template>

              <template #cell(status)="row">
                <i
                  v-if="row.item.status === 'pending'"
                  class="fas fa-minus text-secondary"
                  title="Não enviado"
                />

                <b-spinner
                  v-else-if="row.item.status === 'loading'"
                  small
                />

                <i
                  v-else-if="row.item.status === 'success'"
                  class="fas fa-check text-success"
                  title="Enviado"
                />

                <i
                  v-else-if="row.item.status === 'error'"
                  class="fas fa-exclamation-triangle text-danger"
                  title="Erro"
                />
              </template>

            </b-table>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('close') }}
            </b-button>

            <b-button
              :disabled='!files.length || busy'
              class="mt-3 ml-2"
              variant='primary'
              @click="upload"
            >
              {{ !busy ? (`${$t('save')}`) : 'Salvando...' }}
              <b-spinner v-show="busy" small></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ATTATCHMENT -->
    <div
      ref='modalAttatchment'
      id="modalAttatchment"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAttatchment"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalAttatchmentLabel">OS {{ osToUpload }}</h5>
          </div>

          <div class="modal-body">
            <div
              v-if="showProgressAttatchment"
              class="mb-4"
            >
              <div class="mb-2">
                {{ loadedAttachments }} de {{ totalAttachments }}
              </div>

              <div class="progress progress-bar-default">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: progressPercent + '%' }"
                  :aria-valuenow="progressPercent"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <span class="sr-only">{{ progressPercent }}% Complete</span>
                </div>
              </div>
            </div>

            <div class="lightBoxGallery" v-if="attatchments.length">
              <a
                v-for="(attatchment, index) in attatchments"
                :key="index"
                href="#"
                @click.prevent="zoomImage(attatchment)"
                title="Imagem"
                data-gallery=""
              >
                <template v-if="attatchment.includes('data:image')">
                  <img
                    :src="attatchment"
                    width="100"
                    height="100"
                    style="image-rendering: auto; object-fit: cover; vertical-align: middle;"
                  />
                </template>

                <template v-else-if="attatchment.includes('data:video')">
                  <VideoThumbnail :videoSrc="attatchment" :width="100" :height="100" style="vertical-align: middle;" />
                </template>
              </a>
            </div>

            <div v-if="!showProgressAttatchment" class="text-center">
              <h3>Nenhum anexo encontrado</h3>
            </div>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('close') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ACTIONS AND OS DATA -->
    <div class="modal fade" id="modalActionsAndOsData" tabindex="-1" role="dialog" aria-labelledby="modalActionsAndOsDataLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalActionsAndOsDataLabel">Ações e dados da OS {{ osActionsAndData.id }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" v-if="osActionsAndData.id">
            <ul>
              <li>
                CLIENTE/CONTRATO: <strong>{{ osActionsAndData.contract.contracts }}</strong>
              </li>
              <li>
                EQUIPAMENTO NOVO: <strong>{{ osActionsAndData.serial }}</strong>
              </li>
              <li>
                PLACA: <strong>{{ osActionsAndData.board }}</strong>
              </li>
              <li>
                MARCA: <strong>{{ osActionsAndData.brandName || osActionsAndData.brand }}</strong>
              </li>
              <li>
                MODELO: <strong>{{ osActionsAndData.model }}</strong>
              </li>
              <li>
                COR: <strong>{{ osActionsAndData.color }}</strong>
              </li>
              <li>
                ANO: <strong>{{ osActionsAndData.year }}</strong>
              </li>
              <li>
                TIPO VEÍCULO: <strong>{{ osActionsAndData.vehicleType.TPV_DSC }}</strong>
              </li>
              <li>
                ODÔMETRO: <strong>{{ osActionsAndData.odometer }}</strong>
              </li>
              <li>
                RESULTADO: <strong>{{ osActionsAndData.msgFinish }}</strong>
              </li>
              <li>
                OS ABERTA POR: <strong>{{ osActionsAndData.createdByName || osActionsAndData.createdBy }}</strong>
              </li>
              <li>
                TESTADO POR: <strong>{{ osActionsAndData.technicalUsers.name }}</strong>
              </li>
              <li>
                INSTALADO POR: <strong>{{ osActionsAndData.garageAccredited.fantasyName }}</strong>
              </li>
              <li>
                LOCAL OFICINA: <strong>{{ osActionsAndData.garageAccredited.city }}</strong>
              </li>
              <li>
                SERVIÇO: <strong>{{ osActionsAndData.services.name }}</strong>
              </li>
              <li>
                MOTIVO: <strong>{{ osActionsAndData.maintanceReason ? osActionsAndData.maintanceReason.name : '-' }}</strong>
              </li>
              <li>
                EQUIPAMENTO ANTIGO: <strong>{{ osActionsAndData.withdrawnSerial }}</strong>
              </li>
              <li>
                DATA SERVIÇO: <strong>{{ datePlus3Hours(osActionsAndData.testDate) }}</strong>
              </li>
              <li>
                DATA INSTALAÇÃO: <strong>{{ datePlus3Hours(osActionsAndData.testDate) }}</strong>
              </li>
              <li>
                HOUVE VIAGEM?: <strong>{{ osActionsAndData.travelPayment ? 'SIM' : 'NÃO' }}</strong>
              </li>
              <!-- <li>
                LOCAL SERVIÇO: <strong>{{ '-' }}</strong>
              </li> -->
              <li>
                HOUVE TROCA DE EQUIPAMENTO?: <strong>{{ osActionsAndData.equipmentUsedInReinstallation ? 'SIM' : 'NÃO' }}</strong>
              </li>
              <li>
                LOCAL DA INSTALAÇÃO: <strong>{{ osActionsAndData.trackerInstallationLocal || '-' }}</strong>
              </li>
              <li>
                OBSERVAÇÕES: <strong>{{ osActionsAndData.obs }}</strong>
              </li>
            </ul>

            <hr />

            <div v-if="isLoadingOsActions.show">
              <div
                class="d-flex flex-column align-items-center text-secondary my-2"
              >
                <b-spinner small />

                <strong>{{ isLoadingOsActions.message }}</strong>
              </div>
            </div>

            <div v-else>
              <div class="form-group">
                <label class="col-sm-2 control-label">Ação</label>

                <div class="col-sm-12">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe a ação"
                      v-model="action"
                    >
                      <span class="input-group-btn">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addAction"
                          :disabled="!action"
                        >
                          Adicionar
                        </button>
                      </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <label class="control-label">Anexar imagem</label>

                  <div
                    class="paste-area"
                    @click="triggerFileInput"
                    tabindex="0"
                    @keyup.enter="triggerFileInput"
                  >
                    <span v-if="!actionImagePreview">Cole a imagem aqui ou clique para selecionar</span>

                    <div v-if="actionImagePreview" class="image-preview-container">
                      <img :src="actionImagePreview" class="image-preview" alt="Pré-visualização da imagem" />
                      <button @click.stop="removeActionImage" class="btn btn-danger btn-circle btn-sm remove-image-btn" title="Remover imagem">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>

                  <input
                    type="file"
                    ref="actionImageInput"
                    @change="handleFileSelect"
                    accept="image/*"
                    style="display: none;"
                  />
                </div>
              </div>

              <div class="ibox-content">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Data/Hora</th>
                      <th>Usuário</th>
                      <th>Ação</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="action in osActions" :key="action.id">
                      <td>{{ getFormattedDate(action.createdAt) }}</td>
                      <td>{{ action.user.name }}</td>
                      <td>{{ action.action }}</td>
                      <td>
                        <button
                          v-if="action.attatchment"
                          title="Ver foto"
                          class="mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
                          @click="() => showAttatchment(action.attatchment)"
                          :disabled="loadingAttatchment"
                        >
                          <i class="fas fa-camera" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary block m-b mt-3 mr-2"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="zoomedAttachment"
      class="zoom-overlay"
      @click="closeZoom"
    >
      <img
        v-if="zoomedAttachment.includes('data:image')"
        :src="zoomedAttachment"
        class="zoomed-img"
      />

      <video
        v-else-if="zoomedAttachment.includes('data:video')"
        :src="zoomedAttachment"
        class="zoomed-img"
        controls
        autoplay
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import VideoThumbnail from "@/components/shared/VideoThumbnail";
import LoaderButton from '@/components/button/LoaderButton'
import moment from "moment";
import _ from "lodash";

export default {
  name: "OsListFinishedMaintance",
  components: {
    LDBsTable,
    Combobox,
    LoaderButton,
    VideoThumbnail
  },

  data() {
    return {
      zoomedAttachment: null,
      columns: [
        {
          title: this.$t("os"),
          field: "id",
          width: "50%",
          sortable: true,
        },
        {
          title: this.$t("status"),
          field: "status",
          sortable: true,
          visible: false,
          formatter: (value) => {
            if (value === 1) return "Aguardando";
            if (value === 2) return "Cancelado";
            if (value === 3) return "Concluído";
          },
        },
        {
          title: this.$t("garage_accredited"),
          field: "garageAccredited",
          formatter: function (value) {
            if (!value) {
              return "-";
            }

            const info = [value.fantasyName];

            const city = _.get(value, "city", "");
            const uf = _.get(value, "uf", "");

            city && info.push(city.toUpperCase());
            uf && info.push(uf.toUpperCase());

            return info.join(" - ");
          },
          sortable: true,
        },
        {
          title: this.$t("contract"),
          field: "contract",
          formatter: function (value) {
            return value.contracts;
          },
          sortable: true,
        },
        {
          title: this.$t("new_equipment"),
          field: "serial",
          sortable: true,
        },
        {
          title: this.$t("old_equipment"),
          field: "withdrawnSerial",
          formatter: function (value) {
            return value ? value : "-";
          },
          sortable: true,
        },
        {
          title: this.$t("board"),
          field: "board",
          sortable: true,
          formatter: (value) => {
            return value.length === 7
              ? value.substr(0, 3) + "-" + value.substr(3, 7)
              : value;
          },
        },
        {
          title: this.$t("finished_by"),
          field: "technicalUsers",
          sortable: true,
          formatter: (value) => {
            return value ? value.name : '-'
          }
        },
        {
          title: this.$t("vehicle_type"),
          field: "vehicleType",
          formatter: function (value) {
            return value.TPV_DSC;
          },
          visible: false,
          sortable: true,
        },
        {
          title: this.$t("reason"),
          field: "maintanceReason",
          formatter: function (value) {
            return value ? value.name : "-";
          },
          visible: false,
          sortable: true,
        },
        {
          title: this.$t("problems_found"),
          field: "msgFinish",
          formatter: function (value) {
            if (value) {
              const arr = JSON.parse(value);
              return arr.map((e) => {
                return " " + e;
              });
            }
          },
          visible: false,
          sortable: true,
        },
        {
          title: this.$t("finished_in"),
          field: "testDate",
          formatter: value => value ? this.datePlus3Hours(value) : "",
          sortable: true
        },
        {
          title: this.$t("tracker_installation_local"),
          field: "trackerInstallationLocal",
          visible: false,
        },
        {
          title: this.$t('services'),
          field: 'services',
          formatter: function(value) {
            return value.name
          },
          sortable: true
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "180px",
          formatter: function (value, row) {
            let buttons = `
              <button
                title="Editar"
                data-target="#modalEditOS"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.services.id}"
                class="mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </button>

              <button
                title="Arquivos anexados"
                data-target="#modalAttatchment"
                data-id='${value}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-secondary btn-circle light-bottom-shadow text-white"
                style="opacity: ${row.hasAttatchments ? 1 : 0.5}"
              >
                <i class="fas fa-photo-video" />
              </button>

              <button
                title="Anexar Fotos/Vídeos"
                data-target="#modalUpload"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.id}"
                class="edit mb-1 btn btn-action btn-success btn-circle light-bottom-shadow text-white">
                <i class="fas fa-upload fa-lg" />
              </button>
            `;

            const isResolved = row.osResolved;
            const title = isResolved ? "OS resolvida" : "Marcar como resolvida";
            const btnClass = isResolved ? "btn-secondary" : "btn-success-green";
            const disabledAttr = isResolved ? "disabled" : "";

            buttons += `
              <button
                title="${title}"
                data-target="#modalConfirmResolveOS"
                data-id="${value}"
                data-toggle="modal"
                data-whatever-id="${row.id}"
                data-whatever-board="${row.board}"
                data-whatever-contract="${row.contract.contracts}"
                data-cause-of-maintance="${row.causeOfMaintance}"
                data-service="${row.services.id}"
                class="mb-1 btn btn-action ${btnClass} btn-circle light-bottom-shadow text-white"
                ${disabledAttr}
              >
                <i class="fas fa-check"></i>
              </button>

              <button
                title="Dados da OS e ações"
                data-target="#modalActionsAndOsData"
                data-id="${value}"
                data-toggle="modal"
                class="mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-clipboard-list fa-lg" />
              </button>
            `

            return buttons
          },
        },
      ],
      options: {
        exportOptions: { fileName: "OS-FINISHED" },
      },
      query: {
        id: "",
        number: "",
        garageAccredited: "",
        serial: "",
        withdrawnSerial: undefined,
        contract: "",
        board: "",
        vehicleType: "",
        services: undefined,
        maintanceReason: "",
        causeOfMaintance: undefined,
        status: 3,
        msgFinish: "",
        testDateStart: "",
        testDateEnd: "",
        finishedBy: undefined,
        osResolved: false,
        noStandTest: true,
        countAttatchments: true
      },
      dataToUpdate: {
        id: undefined,
        reason: undefined,
        causeOfMaintance: undefined,
        obs: '',
        generateBilling: false
      },
      serviceTypeOSToEdit: null,
      loading: false,
      queryToUse: {},
      osDataToMarkResolved: {
        id: undefined,
        board: undefined,
        contract: undefined
      },
      alert: {
        show: false,
        type: '',
        message: ''
      },
      file: null,
      busy: false,
      osToUpload: null,
      inputFiles: [],
      files: [],
      showProgressAttatchment: false,
      totalAttachments: 0,
      loadedAttachments: 0,
      osActionsAndData: {},
      action: '',
      actionImage: null,
      actionImagePreview: null,
      loadingAttatchment: false
    }
  },

  computed: {
    ...mapState({
      os: (state) => state.os.all,
      isLoading: state => state.os.isLoading,
      attatchments: state => state.os.attatchments,
      attatchmentByFilename: state => state.os.attatchmentByFilename,
      lastquery: (state) => state.filtershistory.query,
      bsTableData: state => state.bstable.all,
      osActions: state => state.os.osActions,
      isLoadingOsActions: state => state.os.isLoadingOsActions,
    }),

    progressPercent() {
      return this.totalAttachments > 0
        ? Math.round((this.loadedAttachments / this.totalAttachments) * 100)
        : 0;
    },

    onlyMaintanceReasonsActive() {
      const { maintanceReasons } = this.os

      return maintanceReasons && maintanceReasons.length
        ? maintanceReasons.filter(maintanceReason => maintanceReason.isActive)
        : []
    },

    canResolve() {
      const { service, causeOfMaintance } = this.osDataToMarkResolved

      if (service != 2) {
        return true
      }

      return !!causeOfMaintance
    }
  },

  methods: {
    ...mapActions('os', ['editDataOsFinished', 'editCauseOfMaintanceOsFinished']),

    handleFiles(event) {
      const selected = Array.from(event.target.files || this.inputFiles || []);
      // Mescla novos com os já existentes, evitando duplicados
      const names = this.files.map(f => f.name);
      const newFiles = selected.filter(f => !names.includes(f.name));

      const formatted = newFiles.map(file => ({
        file,
        name: file.name,
        status: 'pending'
      }));

      this.files.push(...formatted);
      // limpa input para permitir o reenvio do mesmo arquivo
      this.inputFiles = [];
      event.target.value = '';
    },

    removeFile(index) {
      this.files.splice(index, 1);
    },

    clear() {
      this.query.number = undefined;
      this.query.garageAccredited = undefined;
      this.query.serial = "";
      this.query.withdrawnSerial = undefined;
      this.query.contract = "";
      this.query.board = "";
      this.query.vehicleType = "";
      this.query.maintanceReason = "";
      this.query.msgFinish = "";
      this.query.testDateStart = "";
      this.query.testDateEnd = "";
      this.query.finishedBy = undefined;
    },

    async updateOs(evt, done) {
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          this.errors.add({
            field: 'cause_of_maintance',
            msg: this.$t('ph_cause_of_maintance'),
          })

          return
        }

        const obj = {
          id: this.dataToUpdate.id,
          data: this.dataToUpdate
        }

        this.serviceTypeOSToEdit == 2
          ? await this.editCauseOfMaintanceOsFinished(obj)
          : await this.editDataOsFinished(obj)

        $("#modalEditOS").modal("hide");
        $("#search").trigger("click");
      } catch (error) {
        this.$store.dispatch("notify/error", error);
      }
    },

    async confirmOSResolved() {
      try {
        const { id, service, causeOfMaintance } = this.osDataToMarkResolved

        if (service == 2 && !causeOfMaintance) {
          return
        }

        await this.editDataOsFinished({
          id,
          data: {
            osResolved: true
          }
        })

        $("#modalConfirmResolveOS").modal("hide");
        $("#search").trigger("click");
      } catch (error) {
        this.$store.dispatch("notify/error", error);
      }
    },

    async loadDataToUpdate(idOs) {
      const osData = this.bsTableData.rows.find(item => item.id == idOs)

      this.dataToUpdate = {
        id: idOs,
        obs: osData.obs,
        generateBilling: osData.generateBilling,
        causeOfMaintance: osData.causeOfMaintance
      }

      if (this.serviceTypeOSToEdit == 2) {
        this.dataToUpdate.reason = osData.maintanceReason.id
      }
    },

    async upload() {
      if (!this.files || !this.files.length) {
        return this.alert = {
          show: true,
          type: 'danger',
          message: 'Selecione pelo menos 1 (um) arquivo'
        }
      }

      let someError = false

      for (const file of this.files) {
        if (file.status === 'success') {
          continue
        }

        const formData = new FormData();
        formData.append('file', file.file)

        file.status = 'loading'

        try {
          const uploaded = await this.$store.dispatch(
            'os/uploadAttatchment',
            {
              id: this.osToUpload,
              data: formData
            }
          );

          if (!uploaded) {
            someError = true

            file.status = 'error'

            continue
          }

          file.status = 'success'
        } catch (error) {
          file.status = 'error';

          console.log(`[ERROR-SEND-FILE-${file.name}] => `, error);
        }
      }

      if (!someError) {
        $("#modalUpload").modal("hide");
      }
    },

    zoomImage(url) {
      this.zoomedAttachment = url
    },

    closeZoom() {
      this.zoomedAttachment = null
    },

    async loadAttachmentByOs(id) {
      const filenames = await this.$store.dispatch('os/fetchFilenamesAttachmentsByOs', id)

      if (filenames.length) {
        this.totalAttachments = filenames.length;
        this.loadedAttachments = 0;
        this.showProgressAttatchment = true;

        for (const filename of filenames) {
          await this.$store.dispatch(
            'os/fetchAttachmentByFilename',
            { filename }
          )

          this.loadedAttachments += 1
        }
      }
    },

    clearAttatchments() {
      this.$store.dispatch('os/clearAttatchments')
    },

    getFormattedDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },

    async addAction() {
      if (!this.action) {
        this.$store.dispatch("notify/error", 'É necessário informar uma ação ou anexar uma imagem.');
        return;
      }

      const osId = this.osActionsAndData.id;
      let payload;

      if (this.actionImage) {
        payload = new FormData();
        payload.append('os', osId);
        payload.append('action', this.action);
        payload.append('image', this.actionImage);
      } else {
        payload = {
          os: osId,
          action: this.action,
        };
      }

      const created = await this.$store.dispatch('os/addOsAction', payload);

      if (created) {
        this.loadOsActions(osId);
        this.action = '';
        this.removeActionImage();
      }
    },

    triggerFileInput() {
      this.$refs.actionImageInput.click();
    },

    removeActionImage() {
      this.actionImage = null;
      this.actionImagePreview = null;
      if (this.$refs.actionImageInput) {
        this.$refs.actionImageInput.value = '';
      }
    },

    handleFileSelect(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      const file = files[0];
      if (file && file.type.startsWith('image/')) {
        this.actionImage = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.actionImagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    handlePaste(event) {
      const items = event.clipboardData.items;
      const imageItem = Array.from(items).find(item => item.type.indexOf('image') !== -1);

      if (!imageItem) {
        return;
      }

      event.preventDefault();

      const file = imageItem.getAsFile();
      this.actionImage = file;
      const reader = new FileReader();
      reader.onload = (e) => (this.actionImagePreview = e.target.result);
      reader.readAsDataURL(file);
    },

    loadOsActions(id) {
      this.$store.dispatch('os/fetchOsActions', id)
    },

    datePlus3Hours(date) {
      return moment(date).add(3, 'hours').format("DD/MM/YYYY HH:mm:ss")
    },

    async showAttatchment(filename) {
      try {
        if (this.attatchmentByFilename[filename]) {
          return this.zoomImage(this.attatchmentByFilename[filename])
        }

        this.loadingAttatchment = true

        await this.$store.dispatch(
          'os/fetchAttachmentByFilename',
          {
            filename,
            saveInArray: false
          }
        )

        this.zoomImage(this.attatchmentByFilename[filename])
      } catch (error) {
        console.log('[ERROR-LOADING-ATTATCHMENT] => ', error)
      } finally {
        this.loadingAttatchment = false
      }
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery["oslistfinishedservicemaintance"]
      ? this.lastquery["oslistfinishedservicemaintance"]
      : this.query;
  },

  async mounted() {
    const { dispatch } = this.$store;

    dispatch("overlay/show", true);
    await dispatch("os/fetchAllPageOsList");

    if (this.lastquery["oslistfinishedservicemaintance"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["oslistfinishedservicemaintance"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    const global = this;

    $("#modalEditOS").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.serviceTypeOSToEdit = button.data("whatever")

      global.loadDataToUpdate(button.data("id"));
    });

    $("#modalEditOS").on("hide.bs.modal", function (event) {
      global.dataToUpdate = {
        id: undefined,
        reason: undefined,
        causeOfMaintance: undefined,
        obs: '',
        generateBilling: false
      };

      global.errors.remove('cause_of_maintance')
    });

    $('#modalConfirmResolveOS').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.osDataToMarkResolved = {
        id: button.data('whatever-id'),
        board: button.data('whatever-board'),
        contract: button.data('whatever-contract'),
        causeOfMaintance: button.data('cause-of-maintance'),
        service: button.data('service')
      }
    })

    $('#modalConfirmResolveOS').on('hide.bs.modal', function (event) {
      global.osDataToMarkResolved = {
        id: undefined,
        board: undefined,
        contract: undefined
      }
    })

    $('#modalUpload').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.osToUpload = button.data('id')
    })

    $('#modalUpload').on('hide.bs.modal', function (event) {
      global.osToUpload = null

      global.file = null
      global.inputFiles = null
      global.files = []
    })

    $('#modalAttatchment').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      const osId = button.data('id')

      global.osToUpload = osId

      global.clearAttatchments()
      global.loadAttachmentByOs(osId)
    })

    $('#modalAttatchment').on('hide.bs.modal', function (event) {
      global.clearAttatchments()

      global.showProgressAttatchment = false
    })

    $('#modalActionsAndOsData').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const osId = button.data('id')

      const osData = global.bsTableData.rows.find(row => row.id == osId)

      if (osData) {
        global.osActionsAndData = osData
      }

      global.loadOsActions(osId)

      document.addEventListener('paste', global.handlePaste)
    })

    $('#modalActionsAndOsData').on('hide.bs.modal', function (event) {
      global.osActionsAndData = {}
      global.action = ''
      global.removeActionImage()
      global.$store.dispatch('os/clearOsActions')

      document.removeEventListener('paste', global.handlePaste)

      global.clearAttatchments()
    })

    dispatch("overlay/show", false);
  },

  destroyed() {
    const { dispatch } = this.$store;

    dispatch("maintancereason/cleanState"),
    dispatch("contracts/cleanState"),
    dispatch("vehicletypes/cleanState"),
    dispatch("garageaccredited/cleanState"),
    dispatch("servicetypes/cleanState"),
    dispatch("statusostests/cleanState"),
    dispatch("os/cleanState");
    dispatch("filtershistory/setQuery", {
      key: "oslistfinishedservicemaintance",
      query: this.query,
    });
  },
};
</script>

<style>
  .paste-area {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    color: #777;
    margin-bottom: 10px;
    transition: border-color 0.3s, background-color 0.3s;
  }
  .paste-area:hover, .paste-area:focus {
    border-color: #1ab394; /* Inspinia primary color */
    background-color: #f9f9f9;
    outline: none;
  }
  .image-preview-container {
    position: relative;
    display: inline-block;
  }
  .image-preview {
    max-width: 100%;
    max-height: 150px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
  .remove-image-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    /* Using btn-circle from Inspinia theme */
  }
  .zoom-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: zoom-out;
  }
  .zoomed-img {
    max-width: 90%;
    max-height: 90vh; /* 90% da altura da viewport */
    object-fit: contain; /* Garante que toda a mídia seja visível, mantendo a proporção */
    display: block; /* Remove espaço extra abaixo se for inline */
    margin: auto; /* Ajuda no centro com display:block */
  }
  .video-placeholder {
    width: 100px;
    height: 100px;
    background-color: #000;
    color: white;
    font-size: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
  }
</style>
